import type { ProjectBasicInfoVisibility } from './projectBasicInfoVisibility';

/**
 * 프로젝트 기본 정보
 */
export interface ProjectBasicInfo {
  createdAt?: string;
  description?: string;
  /** 프로젝트 ID (Snowflake ID) */
  id?: number;
  title?: string;
  updatedAt?: string;
  visibility?: ProjectBasicInfoVisibility;
}
